import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box, Grid } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

const visibilityStyles = cssMap({
	hidden: {
		display: 'none',
	},
	invisible: {
		opacity: 0,
		height: '100%',
	},
	visible: {
		opacity: 1,
		height: '100%',
	},
});

const overlayStyles = cssMap({
	default: {
		position: 'absolute',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'start',
		zIndex: 100,
	},
});

const containerStyles = cssMap({
	default: {
		position: 'relative',
		width: '100%',
		height: '100%',
	},
});

export const IframeLoadingScreen = ({
	children,
	iframeLoaded,
	isLoading,
}: {
	children?: React.ReactNode;
	iframeLoaded?: boolean;
	isLoading?: boolean;
}) => (
	<Box xcss={containerStyles.default} aria-busy={isLoading} aria-live="polite">
		<Grid
			gap="space.400"
			alignItems="start"
			xcss={isLoading ? overlayStyles.default : visibilityStyles.hidden}
			aria-hidden={!isLoading}
			role="status"
		>
			<Skeleton width="100%" height="250px" isShimmering />
			<Skeleton width="100%" height="40px" isShimmering />
			<Skeleton width="100%" height="40px" isShimmering />
			<Skeleton width="100%" height="40px" isShimmering />
		</Grid>
		<Box
			padding="space.0"
			aria-hidden={isLoading}
			xcss={!iframeLoaded ? visibilityStyles.invisible : visibilityStyles.visible}
		>
			{children}
		</Box>
	</Box>
);
